(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lameem-contact"] && !Shopify.designMode) return;
  try {
    
/* Topic-driven fields.

   Everything here is enhancement. The markup ships with all
   fields visible and enabled, so with this script blocked the
   form is complete and submittable — just longer.

   Hidden fields are disabled as well as hidden. A hidden-but-
   enabled input still posts, which would put an empty
   "Order number:" line into every sizing enquiry email. */
(function () {
  'use strict';

  function init(root) {
    var select = root.querySelector('[data-lm-topic]');
    if (!select) return;

    var note = root.querySelector('[data-lm-note]');
    var fields = {};
    ['order', 'item', 'height'].forEach(function (key) {
      fields[key] = root.querySelector('[data-lm-field="' + key + '"]');
    });

    function setField(el, show) {
      if (!el) return;
      el.hidden = !show;
      // Disable rather than merely hide, so nothing empty is posted.
      var input = el.querySelector('input, textarea, select');
      if (input) input.disabled = !show;
    }

    function apply() {
      var opt = select.options[select.selectedIndex];

      // No topic chosen yet: show nothing extra rather than
      // everything, so the form does not look longer than it is.
      if (!opt || !opt.value) {
        Object.keys(fields).forEach(function (k) { setField(fields[k], false); });
        if (note) { note.hidden = true; note.textContent = ''; }
        return;
      }

      setField(fields.order, opt.dataset.order === 'true');
      setField(fields.item, opt.dataset.item === 'true');
      setField(fields.height, opt.dataset.height === 'true');

      if (note) {
        var text = opt.dataset.note || '';
        note.textContent = text;
        note.hidden = text === '';
      }
    }

    select.addEventListener('change', apply);
    apply();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.lm-form').forEach(function (form) {
      if (form.dataset.lmContactReady === 'true') return;
      form.dataset.lmContactReady = 'true';
      init(form);
    });

    // Move focus to the outcome so screen-reader users are told
    // what happened instead of being returned to the top of a
    // page that looks unchanged.
    var notice = (scope || document).querySelector('.lm-notice');
    if (notice && window.location.search.indexOf('contact_posted') !== -1) {
      notice.focus();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
